import { generatePath } from '@youhelp-ru/common/routing/client/web';
// eslint-disable-next-line no-duplicate-imports
import type { PathGenerator } from '@youhelp-ru/common/routing/client/web';

export const pathGenerator: PathGenerator = (props, options): string => {
  // eslint-disable-next-line no-undef
  const isDevelopment = process.env.NODE_ENV === 'development';
  return generatePath(props, { logger: isDevelopment ? console : undefined, ...options });
};
